module.exports = __webpack_public_path__ + "static/img/3.6d9eafd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/sp/3.png
// module id = IVrU
// module chunks = 0